<template>
  <section
    id="hero"
    class="hero-section bg6 bg-cover window-height"
    v-if="isHome"
  >
    <div class="inner">
      <img
        class="non-printable visible-sm visible-xs"
        src="/assets/img/backgrounds/kv-mobile.jpg"
        alt=""
      />

      <div class="scroll-indicator">
        <a href="#about">
          <div class="indicator">
            <img src="/assets/img/icons/download.png" alt="" />
          </div>
        </a>
      </div>
    </div>
    <!-- ./inner -->
  </section>
  <section
    id="hero"
    class="section hero-section inner-page bg7 bg-cover light-text"
    v-else
  >
    <div class="inner">
      <div class="hero-bottom">
        <div class="hero-container">
          <div class="inner">
            <div class="row">
              <div class="col-md-8 alpha">
                <h2 class="tagline">
                  The EFG Hermes & Tadawul Investor Conference <br /><br />
                  <span class="sub-head">14 - 17 June 2021</span>
                  <!-- <span>The 16<sup>th</sup> Annual One on One Conference 2020</span>
									<span class="sub-head">Frontier Emerging Markets</span><br />
									Discover the New Emerging Markets -->
                </h2>

                <h6>Virtual online meetings, WebEx</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ./inner -->
  </section>
</template>

<script>
import Navbar from "./Navbar.vue";
export default {
  name: "Header",
  components: { Navbar },
  props: ["isHome"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media print {
  .non-printable {
    display: none;
  }
}
</style>
